jQuery( document ).ready(function($) {

  if($('.demo').length > 0) {
    $('.demo_carousel').owlCarousel({
      loop: true,
      nav: true,
      dots: true,
      navText : ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
      responsive:{
        0:{
          items: 1,
          nav: false,
          autoplay: true,
          autoplayTimeout: 4000,
        },
        600:{
          items: 1
        },
        1000:{
          items: 1
        },
        1440:{
          items: 1
        }
      }
  })}
  // if($('.demo').length > 0) {

  //   if ($(window).width() > 768) {
      
    
  //     let currentStep = 1
  //     let newStep = 0
  //     let $container = $('.demo_scroller')

  //     $container.on('scroll', (e) => {

  //       var scrollPercent = $container.scrollTop() / $container.height();
  //       newStep = (Math.round(scrollPercent)+1)
  //       $('.demo_bar').css('left', (scrollPercent*75/3) + '%')

  //       if(currentStep != newStep) {
  //         changeStep(newStep)
  //         currentStep = newStep
  //       }
  //     });

  //     const changeStep = (stepNumber) => {
        
  //       $('.demo_stepNumber').removeClass('demo_stepNumber-active')
        
  //       setTimeout(() => {
  //         $('.demo_stepNumber').removeClass('demo_stepNumber-active')
  //         $('.demo_stepNumber-' + stepNumber).addClass('demo_stepNumber-active')
  //         $('.demo_step').removeClass('demo_step-active')
  //         $('.demo_step-' + stepNumber).addClass('demo_step-active')
  //       }, 1000);

  //       $('.demo_item').removeClass('demo_item-active')
  //       $('.demo_item-' + stepNumber).addClass('demo_item-active')

  //       if(stepNumber == 1) {
  //         $('.demo_progressCircle').find('path').css('stroke-dashoffset', 1287)
  //       }

  //       if(stepNumber == 2) {
  //         $('.demo_progressCircle').find('path').css('stroke-dashoffset', 917)
  //       }

  //       if(stepNumber == 3) {
  //         $('.demo_progressCircle').find('path').css('stroke-dashoffset', 550)
  //       }

  //       if(stepNumber == 4) {
  //         $('.demo_progressCircle').find('path').css('stroke-dashoffset', 200)
  //       }
  //     }

  //   }
  // }
});

